module.exports = __webpack_public_path__ + "img/app.55d23877.png";